module.exports = __webpack_public_path__ + "static/img/20260905-02.e3688f1.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/20260905-02.webp
// module id = P0EI
// module chunks = 1